import React from 'react';
import './Fiestas.css';

import ParroquiaImg            from '../../Images/Parroquia.jpeg';
import CristoCruzAcuestasImg   from '../../Images/CristoCruzAcuestas.jpg';
import FiestasCristoImg        from '../../Images/FiestasCristo.jpg';

const Fiestas = () => (
  <div className="fiestas-container">
    <h1>Fiestas de Escalonilla</h1>
    <p>
      Devoción, historia y folclore se mezclan en las grandes celebraciones de
      nuestro calendario. Procesiones centenarias, novenas, suelta de vaquillas
      y antiguas <em>danzas “a la corbicana”</em> convierten al pueblo en punto de
      encuentro para vecinos y descendientes.
    </p>

    {/* 1 ▸ SANTA Mª MAGDALENA */}
    <div className="fiesta-section">
      <h2>22 de julio · Santa María Magdalena</h2>
      <div className="fiesta-content">
        <div className="fiesta-text">
          <p>
            Patrona documentada desde <b>1556</b>, cuando ya existía su cofradía
            «obligada a misa, vísperas, sermón y procesión solemne». En la
            Edad Media la fiesta estaba clasificada como <i>dies duplex</i>; quien no la
            guardaba arriesgaba “rayos y pestes”, según una fama piadosa repetida
            por los franciscanos.
          </p>
          <p>
            La procesión parte a las 21 h entre sones de dulzaina; desde
            los noventa acompaña <b>San Germán</b> para favorecer la participación de
            portadores. El paso atraviesa “la corraliza” mientras se interpreta la
            <em>Jota de la Magdalena</em> con guitarrillo y violín, recogida en 1812.
          </p>
          <p>
            Tras el desfile se celebra el «<i>paloteo</i>», antiguo baile de varas que ya
            sorprendió al comisionado constitucional Jacinto Sánchez Palomo en
            1812. Hoy se mantiene gracias al grupo <i>Chimenea</i>; los danzantes lucen
            cintas escarlata y cascabeles.
          </p>
          <p>
            Actos actuales: novenario con ofrenda floral, pasacalles de gigantes,
            torneo de truque y chito, cena popular a base de
            <i>carcamusas con pisto</i> y verbena hasta el amanecer.
          </p>
        </div>
        <div className="fiesta-images">
          <img src={ParroquiaImg}            alt="Parroquia iluminada" />
        </div>
      </div>
    </div>


    {/* 3 ▸ FIESTAS DEL CRISTO */}
    <div className="fiesta-section">
      <h2>6-14 de septiembre · Santísimo Cristo de la Cruz a Cuestas</h2>
      <div className="fiesta-content">
        <div className="fiesta-text">
          <p>
            <b>Fiesta mayor</b> del municipio, nacida tras el brote de cólera de 1834. El
            novenario arranca el día 6 y culmina el 14 con la <em>procesión del Cristo</em>,
            portada a hombros por 32 anderos que se relevan al son de marchas
            fúnebres. El paso se abre con arcos de romero «para que el olor a campo
            acompañe al Redentor».
          </p>
          <p>
            Tradiciones singulares:
            <br />• <b>«Motetes»</b> nocturnos (coplas del XVIII cantadas a dos coros).<br />
            • <b>Suelta de vaquillas</b> en la plaza –documentada desde 1907– y concurso
            de recortes.<br />
            • <b>Farolillos de melón</b>: los niños vacían melones de secano, tallan cruces
            y colocan velas para guiar al Cristo en su regreso.
          </p>
          <p>
            El 11 de septiembre tiene lugar el <i>Día del Ausente</i>: cientos de
            escalonilleros emigrados regresan, reciben un pañuelo de raso carmesí y
            firman en el «Libro del Retorno».
          </p>
          <p>
            Tras la pólvora final, el Cristo entra mientras la banda interpreta
            <b>«La Madrugá»</b>. El hermano mayor cierra la puerta y, como recoge la
            crónica de 1898, «cesan los clamores y comienza el invierno del alma
            escalonillera».
          </p>
        </div>
        <div className="fiesta-images">
          <img src={CristoCruzAcuestasImg} alt="Imagen del Cristo de la Cruz a Cuestas" />
        </div>
      </div>
    </div>
  </div>
);

export default Fiestas;

